import { Navigate, Outlet } from 'react-router-dom-v5-compat';

import { ROLE_LEVELS, useAuthLevel } from '../../hooks/useCurrentUser';

// Manager/Staff gate for the Tickete routes, mounted INSIDE the v2 Shell (so the
// sidebar + header chrome stay). Crucially it withholds the page until the role
// has loaded — `undefined` means "still hydrating" (show a loader, don't
// redirect; see useAuthLevel). Only when allowed does it render <Outlet/>, so
// the page mounts with the user fully loaded and its role-based defaults are
// correct on the first render.
export default function TicketsGate() {
    const level = useAuthLevel();

    if (level === undefined) {
        return (
            <div className="flex h-64 w-full items-center justify-center text-sm text-gray-500 dark:text-gray-400">
                Se incarca...
            </div>
        );
    }
    if (level < ROLE_LEVELS.MANAGER) return <Navigate to="/v2/products" replace />;
    return <Outlet />;
}
